import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = {
  class: "overflow-auto",
  style: {"min-height":"100vh"}
}
const _hoisted_7 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "text-capitalize-first" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { colspan: "2" }
const _hoisted_16 = { colspan: "2" }
const _hoisted_17 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.source')) + " A", 1),
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.rate')), 1),
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.source')) + " B", 1),
                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.rate')), 1),
                        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.diffSum')), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compareList, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`rate_sources.${item.rateA.source}`)) + " " + _toDisplayString(item.rateA.toCurrency) + "/" + _toDisplayString(item.rateA.fromCurrency), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.getRate(item.rateA), 6)) + " " + _toDisplayString(item.rateA.fromCurrency), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`rate_sources.${item.rateB.source}`)) + " " + _toDisplayString(item.rateB.toCurrency) + "/" + _toDisplayString(item.rateB.fromCurrency), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.getRate(item.rateB), 6)) + " " + _toDisplayString(item.rateB.fromCurrency), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.getDiff(item.rateA, item.rateB), 6)) + " " + _toDisplayString(item.rateA.fromCurrency) + " (" + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.getDiffPercent(item.rateA, item.rateB), 2)) + "%) ", 1),
                          _createElementVNode("td", _hoisted_13, [
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (_ctx.remove(index)), ["prevent"]),
                              class: "btn btn-outline-danger"
                            }, _cache[4] || (_cache[4] = [
                              _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                            ]), 8, _hoisted_14)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_15, [
                          _createVNode(_component_Multiselect, {
                            class: "",
                            modelValue: _ctx.form.sourceA,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.sourceA) = $event)),
                            options: _ctx.currencies,
                            "custom-label": (opt) => _ctx.helper.trans(`rate_sources.${opt.source}`) + ` ${opt.toCurrency}/${opt.fromCurrency}`,
                            "select-label": "Select",
                            placeholder: "",
                            "open-direction": "bottom",
                            multiple: false,
                            searchable: true,
                            "internal-search": true,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "options-limit": 100,
                            limit: 1000,
                            "show-no-results": false,
                            "hide-selected": false
                          }, null, 8, ["modelValue", "options", "custom-label"])
                        ]),
                        _createElementVNode("td", _hoisted_16, [
                          _createVNode(_component_Multiselect, {
                            class: "",
                            modelValue: _ctx.form.sourceB,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.sourceB) = $event)),
                            options: _ctx.currencies,
                            "custom-label": (opt) => _ctx.helper.trans(`rate_sources.${opt.source}`) + ` ${opt.fromCurrency}/${opt.toCurrency}`,
                            "select-label": "Select",
                            placeholder: "",
                            "open-direction": "bottom",
                            multiple: false,
                            searchable: true,
                            "internal-search": true,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "options-limit": 100,
                            limit: 1000,
                            "show-no-results": false,
                            "hide-selected": false
                          }, null, 8, ["modelValue", "options", "custom-label"])
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1)),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("button", {
                            class: "btn btn-outline-primary text-capitalize-first",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)), ["prevent"]))
                          }, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}